import { mutateApi, queryApi } from "src/utils/api/ApiMethods"
import { buildQueryString } from "src/utils/api/query_param_helpers"

export const getWorkOrder = (marinaSlug, sequentialId) =>
  queryApi(
    `/manage/${marinaSlug}/service/work_orders/${sequentialId}.json`
  ).then((response) => response.data)

export const createWorkOrder = (
  marinaSlug,
  { contactId, contactBoatId, requestDescription }
) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/work_orders`,
    method: "POST",
    data: {
      work_order: {
        contact_id: contactId,
        contact_boat_id: contactBoatId,
        request_description: requestDescription,
      },
    },
  }).then((response) => response.data)

export const scheduleWorkOrder = (marinaSlug, sequentialId, { scheduledAt }) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/work_orders/${sequentialId}/schedule`,
    method: "PATCH",
    data: {
      work_order: { scheduled_at: scheduledAt },
    },
  }).then((response) => response.data)

export const closeWorkOrder = (marinaSlug, sequentialId) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/work_orders/${sequentialId}/close`,
    method: "POST",
  }).then((response) => response.data)

export const reopenWorkOrder = (marinaSlug, sequentialId) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/work_orders/${sequentialId}/reopen`,
    method: "POST",
  }).then((response) => response.data)

export const getBillableJobs = (marinaSlug, sequentialId) =>
  queryApi(
    `/manage/${marinaSlug}/service/work_orders/${sequentialId}/billable_jobs.json`
  ).then((response) => response.data)

export const getInvoicePreview = (marinaSlug, sequentialId, jobIds) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/work_orders/${sequentialId}/invoice_preview`,
    method: "POST",
    data: { job_ids: jobIds },
  }).then((response) => response.data)

export const generateInvoice = (
  marinaSlug,
  sequentialId,
  { jobIds, dueDate, sendEmail, autopayEnabled, stripePaymentMethodId }
) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/work_orders/${sequentialId}/generate_invoice`,
    method: "POST",
    data: {
      invoice: {
        job_ids: jobIds,
        due_date: dueDate,
        send_email: sendEmail,
        autopay_enabled: autopayEnabled,
        stripe_card_id: autopayEnabled ? stripePaymentMethodId : null,
      },
    },
  }).then((response) => response.data)

export const updateAutopay = (
  marinaSlug,
  sequentialId,
  { autopayEnabled, stripePaymentMethodId, applyToExisting }
) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/work_orders/${sequentialId}/autopay`,
    method: "PATCH",
    data: {
      autopay_enabled: autopayEnabled,
      stripe_card_id: stripePaymentMethodId,
      apply_to_existing: applyToExisting,
    },
  }).then((response) => response.data)

export const getPaymentMethodOptions = (marinaSlug, sequentialId) =>
  queryApi(
    `/manage/${marinaSlug}/service/work_orders/${sequentialId}/payment_method_options.json`
  ).then((response) => response.data)

// Renders the bare invoice (snake_case), so consume the response directly —
// no `.data` envelope, matching the Billing invoices update path.
export const updateInvoiceAutopay = (
  marinaSlug,
  sequentialId,
  invoiceId,
  { autopayEnabled, stripePaymentMethodId }
) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/work_orders/${sequentialId}/invoices/${invoiceId}/autopay`,
    method: "PATCH",
    data: {
      autopay_enabled: autopayEnabled,
      stripe_card_id: autopayEnabled ? stripePaymentMethodId : null,
    },
  })

export const getWorkOrderInvoices = (marinaSlug, sequentialId, params = {}) =>
  queryApi(
    `/manage/${marinaSlug}/service/work_orders/${sequentialId}/invoices${buildQueryString(
      params
    )}`
  )

export const getWorkOrderInvoiceIds = (marinaSlug, sequentialId, params = {}) =>
  queryApi(
    `/manage/${marinaSlug}/service/work_orders/${sequentialId}/invoices/selectable_ids${buildQueryString(
      params
    )}`
  )
